import 'amfe-flexible'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/global.css'
import vants from '@/methods/vant.js';
const app = createApp(App)
app.use(vants)
app.use(store).use(router).mount('#app')
